import { render } from "./PointOfPurchase.vue?vue&type=template&id=5c168c2e"
import script from "./PointOfPurchase.vue?vue&type=script&lang=js"
export * from "./PointOfPurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__